import React from "react";


const BusinessSummaryCard = ({
    icon: Icon,
    label = "",
    title = "",
    value = 0,
    subtitle = "",
    description = "",
    className = "",
    onClick = null,
}) => {

    const displayLabel =
        label ||
        title;


    const clickable =
        typeof onClick ===
        "function";


    return (

        <div
            className={[
                "platform-business-summary-card",

                clickable
                    ? "platform-business-summary-card-clickable"
                    : "",

                className,
            ]
                .filter(Boolean)
                .join(" ")
            }

            onClick={
                clickable
                    ? onClick
                    : undefined
            }

            role={
                clickable
                    ? "button"
                    : undefined
            }

            tabIndex={
                clickable
                    ? 0
                    : undefined
            }

            onKeyDown={(event) => {

                if (
                    !clickable
                ) {
                    return;
                }


                if (
                    event.key === "Enter" ||
                    event.key === " "
                ) {

                    event.preventDefault();

                    onClick();

                }

            }}
        >

            {Icon ? (

                <div className="platform-business-summary-icon">

                    <Icon />

                </div>

            ) : null}


            <div className="platform-business-summary-content">

                {displayLabel ? (

                    <span className="platform-business-summary-label">

                        {displayLabel}

                    </span>

                ) : null}


                <strong className="platform-business-summary-value">

                    {
                        value ??
                        0
                    }

                </strong>


                {
                    subtitle ||
                    description
                        ? (

                            <small className="platform-business-summary-subtitle">

                                {
                                    subtitle ||
                                    description
                                }

                            </small>

                        )
                        : null
                }

            </div>

        </div>

    );

};


export default BusinessSummaryCard;